import { useReducer } from 'react';
import { type } from './solicitudCoberturaActions';
import { SolicitudCoberturaContext } from './SolicitudCoberturaContext';
import { solicitudCoberturaReducer } from './solicitudCoberturaReducer';

const init = () => {
  return {
    anualList: [],
    mensualDate: null,
    mensualList: [],
    anualDate: null,
  };
};

export const SolicitudCoberturaProvider = ({ children }) => {
  const [solicitudCoberturaState, dispatch] = useReducer(solicitudCoberturaReducer, {}, init);

  const setSolicitudCoberturaAnualList = (solicitudes) => {
    dispatch({
      type: type.anualList,
      payload: solicitudes.data,
      date: solicitudes.date,
    });
  };

  const setSolicitudCoberturaMensualList = (solicitudes) => {
    dispatch({
      type: type.mensualList,
      payload: solicitudes.data,
      date: solicitudes.date,
    });
  };

  return (
    <SolicitudCoberturaContext.Provider
      value={{
        ...solicitudCoberturaState,
        setSolicitudCoberturaAnualList,
        setSolicitudCoberturaMensualList,
      }}
    >
      {children}
    </SolicitudCoberturaContext.Provider>
  );
};
